import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import NTMgallery from './NTMGallery';

import BreadCrumbImage from '../../Images_1/CommonSection/Braedcrumbs/gallery.jpg';

import './Gallery.css';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import RMgallery from './RMgallery';
import PMgallery from './PMgallery';
import EMgallery from './EMgallery';
import DefaultGallery from './DefaultGallery';

function Gallery(props) {

    const [selecteddiv, setSelecteddiv] = useState('img-1');

    const selectedStyle = { color: "#7cba27" };

    return (
        <div>
            {/* Title Bar */}
            <BreadCrumbs parent="Home" child="Gallery" parentPath="/" imgPath={BreadCrumbImage} />
            {/* Title Bar End */}

            <section className="gallery-section">
                <div className="gallery-main-div">
                    <div className="gallery-list-div">
                        <div className="gallery-list-bg">
                            <div className="gallery-border-div">
                                <div className="gallery-all-post-list">
                                    <ul>
                                        <li className="gallery-post-active"
                                        ><Link to="#" style={selecteddiv == 'img-1' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-1');
                                            }}>All Highlights</Link></li>

                                        <li><Link to="#" style={selecteddiv == 'img-2' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-2');
                                            }}>MoUs & Strategic Partnerships</Link></li>
                                              <li><Link to="#" style={selecteddiv == 'img-3' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-3');
                                            }}>Trainings & Conferences</Link></li>
                                              <li><Link to="#" style={selecteddiv == 'img-4' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-4');
                                            }}>Delegates & Official Visits</Link></li>
                                              <li><Link to="#" style={selecteddiv == 'img-5' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-5');
                                            }}>Events & Celebrations</Link></li>
                                    </ul>
                                    {/* <ul>
                                        <li className="ssd-post-active"
                                        ><Link to="#" style={selecteddiv == 'img-3' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-3');
                                            }}>Solar Laboratory Facilities</Link></li>

                                        <li><Link to="#" style={selecteddiv == 'img-4' ? selectedStyle : {}}
                                            onClick={() => {
                                                setSelecteddiv('img-4');
                                            }}>Environment Laboratory Facilities</Link></li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="gallery-content-div">
                        <div className='img-1 gallery-images' style={selecteddiv == 'img-1' ? { display: 'flex' } : { display: 'none' }}>
                            <h2 className='gallery-heading'>All Highlights</h2>
                            <EMgallery />
                        </div>

                        <div className='img-2 gallery-images' style={selecteddiv == 'img-2' ? { display: 'flex' } : { display: 'none' }}>
                            <h2 className='gallery-heading'>MoUs & Strategic Partnerships</h2>
                           <NTMgallery />
                        </div>

                        <div className='img-3 gallery-images' style={selecteddiv == 'img-3' ? { display: 'flex' } : { display: 'none' }}>
                            <h2 className='gallery-heading'>Trainings & Conferences</h2>
                            {/* <PMgallery /> */}
                            <PMgallery />
                        </div>

                        <div className='img-4 gallery-images' style={selecteddiv == 'img-4' ? { display: 'flex' } : { display: 'none' }}>
                            <h2 className='gallery-heading'>Delegates & Official Visits</h2>
                            {/* <EMgallery /> */}
                            <PMgallery />
                        </div>
                        <div className='img-5 gallery-images' style={selecteddiv == 'img-5' ? { display: 'flex' } : { display: 'none' }}>
                            <h2 className='gallery-heading'>Events & Celebrations</h2>
                            {/* <EMgallery /> */}
                            <RMgallery />
                        </div>
                    </div>
                </div>
            </section>
        </div >
    );
}

export default Gallery
